import { StaffManagementContainer } from '@/components/staff/StaffManagementContainer';

export default function StaffManagement() {
  return <StaffManagementContainer />;
}
